// Dependencies determine the display order; source order only breaks ties between branches.
export function orderedQuestChain(quests, matchingIds = new Set(quests.map(q => q.id))) {
  const byId = new Map(quests.map(q => [q.id, q]));
  const included = new Set();
  for (const id of matchingIds) {
    let q = byId.get(id);
    while (q && !included.has(q.id)) {
      included.add(q.id);
      q = byId.get(q.requiredQuestId);
    }
  }
  const children = new Map();
  for (const q of quests) {
    if (!included.has(q.id)) continue;
    if (!children.has(q.requiredQuestId)) children.set(q.requiredQuestId, []);
    children.get(q.requiredQuestId).push(q);
  }
  const rows = [], visited = new Set();
  const visit = (start, cycle = false) => {
    const stack = [{ quest: start, branchDepth: 0, branchStart: false }];
    while (stack.length) {
      const row = stack.pop(), q = row.quest;
      if (visited.has(q.id)) continue;
      visited.add(q.id);
      rows.push({ ...row, cycle, context: !matchingIds.has(q.id) });
      const next = children.get(q.id) || [];
      for (let i = next.length - 1; i >= 0; i--) stack.push({ quest: next[i], branchDepth: row.branchDepth + (next.length > 1 ? 1 : 0), branchStart: next.length > 1 });
    }
  };
  for (const q of quests) if (included.has(q.id) && !included.has(q.requiredQuestId)) visit(q);
  // Malformed cycles must not hide quests or loop forever.
  for (const q of quests) if (included.has(q.id) && !visited.has(q.id)) visit(q, true);
  return rows;
}

export function questCatalogSections(quests, results) {
  const matchingIds = new Set(results.map(q => q.id));
  const buckets = new Map();
  for (const q of quests) {
    const key = JSON.stringify([q.clan, q.category, q.group || '']);
    if (!buckets.has(key)) buckets.set(key, []);
    buckets.get(key).push(q);
  }
  const chains = [], grouped = new Set();
  for (const [key, members] of buckets) {
    const ids = new Set(members.map(q => q.id));
    const matching = members.filter(q => matchingIds.has(q.id));
    if (!matching.length || !members.some(q => ids.has(q.requiredQuestId))) continue;
    const rows = orderedQuestChain(members, new Set(matching.map(q => q.id)));
    chains.push({ key, title: members[0].group || members[0].name, rows, count: members.length, matches: matching.length });
    members.forEach(q => grouped.add(q.id));
  }
  return { chains, standalone: results.filter(q => !grouped.has(q.id)) };
}
